import { render, staticRenderFns } from "./LEDTableExpansion.vue?vue&type=template&id=181810b6&scoped=true&"
import script from "./LEDTableExpansion.vue?vue&type=script&lang=js&"
export * from "./LEDTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./LEDTableExpansion.vue?vue&type=style&index=0&id=181810b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181810b6",
  null
  
)

export default component.exports